import React from 'react';

interface LoadMoreButtonProps {
  disabled: boolean;
  loadMore: VoidFunction;
}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({ disabled, loadMore }) => (
  <button
    type="button"
    className="relative inline w-1/3 transform rounded-md bg-yellow-300 px-8 py-2 text-center transition-transform active:scale-95 dark:bg-yellow-600"
    onClick={loadMore}
    disabled={disabled}
  >
    Ещё
  </button>
);

export default LoadMoreButton;
